import { useTranslation } from "react-i18next";

import { Table } from "@4uhub/lib4uhub";
import { Box, Chip, Typography } from "@mui/material";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { memo, useCallback, useState } from "react";
import { IVariablesInternalTemplates } from "../../../../../models/internal-templates";
import MainApi from "../../../../../services/mainApi.service";
import Variables from "./VariablesForm/Variables";
const translationsPath = "chatBot.page.templates.internalCrm.";

const serviceURL =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationInternalTemplateVariable/";
const service = new MainApi<IVariablesInternalTemplates>(serviceURL);

export const VariablesPage = memo(() => {
  const [templateInternalForm, setTemplateInternalForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();
  const { t } = useTranslation();
  const translate = (field: string) => t(translationsPath + field);

  const columns: GridColDef<IVariablesInternalTemplates>[] = [
    {
      field: "code",
      headerName: t(translationsPath + "code") || "Code",
      renderCell: ({ value }) => (
        <Typography variant="body2">{value}</Typography>
      ),
    },
    {
      field: "name",
      headerName: t(translationsPath + "name") || "Name",
      renderCell: ({ value }) => (
        <Typography variant="body2">{value}</Typography>
      ),
    },
    {
      field: "dataType",
      headerName: t(translationsPath + "data_type") || "Data Type",
      renderCell: ({ value }) => (
        <Typography variant="body2">{value.name}</Typography>
      ),
    },
    {
      field: "category",
      headerName: t(translationsPath + "category") || "Category",
      renderCell: ({ value }) => (
        <Typography variant="body2">{value.name}</Typography>
      ),
    },
    {
      field: "enable",
      headerName: t(translationsPath + "status") || "Status",
      renderCell: (params) => (
        <Chip
          size="small"
          label={
            params.value
              ? t(translationsPath + "active")
              : t(translationsPath + "inactive")
          }
          color={params.value ? "success" : "error"}
        />
      ),
    },
  ];

  const handleAdd = () => {
    setTemplateInternalForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<IVariablesInternalTemplates>
  ) => {
    if (!params.row) return;
    setTemplateInternalForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTemplateInternalForm(false);
  }, []);

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      {templateInternalForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <Variables id={selectedId} onBackButton={handleBack} />
        </Box>
      )}
      {!templateInternalForm && (
        <Table<IVariablesInternalTemplates>
          searchInput
          showDefaultMacroFilters={false}
          columns={columns}
          service={service}
          onAdd={handleAdd}
          onRowClick={handleRowClick}
          title={translate("variables")}
          addButtonLabel={translate("new_variable")}
          searchInputPlaceHolder={translate("search_variable")}
          confirmOptions={{
            title: translate("confirm.title_variable"),
            description: translate("confirm.description_variable"),
            confirmationButtonProps: { variant: "contained" },
          }}
        />
      )}
    </Box>
  );
});
